import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private DOMAIN = 'domain';

  constructor() {
  }

  setDomain(domain: string) {
    sessionStorage.setItem(this.DOMAIN, domain)
  }

  getDomain(): string {
    return sessionStorage.getItem(this.DOMAIN)
  }

  flushDomain() {
    sessionStorage.removeItem(this.DOMAIN)
  }
}
